import { render } from "./prescriptionPayment.vue?vue&type=template&id=50e3c93f&scoped=true"
import script from "./prescriptionPayment.vue?vue&type=script&lang=js"
export * from "./prescriptionPayment.vue?vue&type=script&lang=js"

import "./prescriptionPayment.vue?vue&type=style&index=0&id=50e3c93f&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e3c93f"]])

export default __exports__